import { NgModule } from '@angular/core';
import { AuthenInterceptor } from './authen.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenService } from './authen.service';

@NgModule({
    providers: [
        { useClass: AuthenInterceptor, provide: HTTP_INTERCEPTORS, multi: true },
        AuthenService
    ]
})
export class AuthenServiceModule { }
